// extracted by mini-css-extract-plugin
export var button = "_cc-0";
export var icon = "_cc-1";